var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.shape,style:({
    backgroundColor: _vm.bg,
    height: `${_vm.size}px`,
    width: `${_vm.size}px`,
    minWidth: `${_vm.size}px`,
  }),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }